<ov-admin-login *ngIf="!logged" [error]="error" (onLoginButtonClicked)="onLoginClicked($event)"></ov-admin-login>

<ov-admin-dashboard
	*ngIf="logged"
	[recordingsList]="recordings"
	(onLogoutClicked)="onLogoutClicked()"
	(onRefreshRecordingsClicked)="onRefreshRecordingsClicked()"
	(onDeleteRecordingClicked)="onDeleteRecordingClicked($event)"
></ov-admin-dashboard>
